// src/components/LegacyRoutePage.tsx
'use client'; // 雖然 dynamic ssr:false 會處理，但加個標記更清楚

import dynamic from 'next/dynamic';
import React from 'react';

// 統一在這裡處理 dynamic import，不用到處複製貼上
const LegacyAppEntryDynamic = dynamic(() => import('@/components/LegacyAppEntry'), {
    ssr: false,
});

// 給它一個好聽的名字，這樣你在 React DevTools 就不會看到一堆重複的 "ProductsCatchAllPage"
export default function LegacyRoutePage() {
    return <LegacyAppEntryDynamic />;
}
